import { useEffect, useState } from "react";
import { CloudOff, Loader2 } from "lucide-react";
import { flushOutbox } from "@/lib/api";
import { onOutbox, outboxCount } from "@/lib/outbox";

// "Offline · 3 waiting to send": shows while there's no signal or saved changes are still waiting; sends them when back online.
export default function OutboxBadge() {
  const [online, setOnline] = useState(navigator.onLine);
  const [waiting, setWaiting] = useState(0);
  useEffect(() => {
    outboxCount().then(setWaiting);
    const off = onOutbox(setWaiting);
    const up = () => { setOnline(true); flushOutbox(); };
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    flushOutbox();
    const t = setInterval(() => { if (navigator.onLine) flushOutbox(); }, 30000);
    return () => { off(); window.removeEventListener("online", up); window.removeEventListener("offline", down); clearInterval(t); };
  }, []);
  if (online && !waiting) return null;
  return (
    <div className="pt-safe fixed left-1/2 top-14 z-[61] flex -translate-x-1/2 items-center gap-1.5 rounded-full bg-slate-900 px-3 py-1.5 text-[11px] font-semibold text-white shadow-lg" data-testid="outbox-badge" role="status">
      {online ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CloudOff className="h-3.5 w-3.5 text-amber-300" />}
      {online ? `Sending ${waiting} saved change${waiting === 1 ? "" : "s"}…` : `Offline${waiting ? ` · ${waiting} waiting to send` : " · saves will wait on this phone"}`}
    </div>
  );
}
